const cache = {}

export async function getFieldData(element, language, {minisiteId}) {
	if (cache[element]) {
		return cache[element]
	}

	const API_URL = import.meta.env.DEV
		? 'http://localhost:5712'
		: 'https://forms-api.webcloud.cloud'

	if (element === 'select-minisiteevent') {
		const req = await fetch(`${API_URL}/minisite_events/${minisiteId}`, {
			headers: {'x-language': language.code},
		})
		const res = await req.json()

		cache[element] = res
		return res
	}

	if (element === 'select-roomtype') {
		const req = await fetch(`${API_URL}/minisite_rooms/${minisiteId}`, {
			headers: {'x-language': language.code},
		})
		const res = await req.json()

		cache[element] = res
		return res
	}

	if (element === 'select-treatment') {
		const req = await fetch(`${API_URL}/minisite_treatments/${minisiteId}`, {
			headers: {'x-language': language.code},
		})
		const res = await req.json()

		cache[element] = res
		return res
	}

	throw new Error('Invalid element in getFieldData', element)
}
